// d06665ebe0d5eb3fe188ec137a555da003903dad|name=ChatMessageRating|schemaHash=80d21d53865db3d342a35dee699a330be84121d2|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseChatMessageRatingFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'sentiment', _data.sentiment);
  setDefinedValue(result, 'category', _data.category);
  setDefinedValue(result, 'comment', _data.comment);

  return result;
}

export function parseChatMessageRatingToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'sentiment', _data.sentiment);
  setDefinedValue(result, 'category', _data.category);
  setDefinedValue(result, 'comment', _data.comment);

  return result;
}
